import * as React from 'react';
import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { MarketConfigType, MarketsByRegionType, ProductConfigType } from '../../../types/administrationTypes';
import TFFAccordionNew from '../../../styled-components/TFFAccordionNew';

interface MarketsConfigurationProps {
  marketsState: MarketsByRegionType;
  setMarketsState: React.Dispatch<React.SetStateAction<MarketsByRegionType>>;
  productsList: ProductConfigType[];
  setProductsList: React.Dispatch<React.SetStateAction<ProductConfigType[]>>;
}

const MarketsConfiguration: React.FC<MarketsConfigurationProps> = ({
  marketsState,
  setMarketsState,
  productsList,
  setProductsList,
}) => {
  const intl = useIntl();

  return (
    <div className="tff-administration-col-4">
      <Typography variant="h6" color="primary">
        <strong>{intl.formatMessage({ id: 'administration.myMarkets' })}</strong>
      </Typography>
      <div>
        {Object.entries(marketsState).map(([regionName, markets]) => (
          <div key={regionName}>
            <TFFAccordionNew
              noStyle
              accordionId={regionName}
              summaryChildren={regionName}
              detailsChildren={
                <div className="tff-administration-flex-column">
                  {markets.map((market: MarketConfigType, index: number) => {
                    const handleMarketsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
                      const newState = { ...marketsState };
                      newState[regionName as keyof MarketsByRegionType] = markets.map(item =>
                        item.value === market.value ? { ...item, selected: event.target.checked } : item,
                      );
                      setMarketsState(newState);
                      const newProductsState = productsList.map(item => {
                        return item.belongsTo.includes(market.value)
                          ? { ...item, disabled: !event.target.checked }
                          : item;
                      });
                      setProductsList(newProductsState);
                    };
                    return (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={market.selected}
                            onChange={handleMarketsChange}
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                            name={market.name}
                          />
                        }
                        label={market.name}
                        key={`${regionName}-${index}`}
                        className="tff-administration-form-label-width"
                      />
                    );
                  })}
                </div>
              }
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default MarketsConfiguration;
